/**
 * @generated SignedSource<<71cff092e89e46a362be06e134620ee1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotAOneOnOne_note$data = {
  readonly id: string;
  readonly " $fragmentType": "NotAOneOnOne_note";
};
export type NotAOneOnOne_note$key = {
  readonly " $data"?: NotAOneOnOne_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotAOneOnOne_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotAOneOnOne_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "ff32ebd0d664338eab4a503272629eb4";

export default node;
